<template>
  <div class="eventContentainer">
        <transition-group name="events" tag='div' >
            <div 
                class="eventItem"
                v-for=" event in item.detail  "
                :key="event.title"
            >
                <div class="eventText"> 
                        <h3 class="titleEvent" v-html="event.title"></h3>
                        <h4 class="subtitleEvent" >{{event.subtitle}} <span class='eventYears' >{{event.start +" al "+ event.end}}</span></h4>
                        <div class="descriptionEvent" v-html="event.description"></div>
                </div>
                <div v-if="event.image" class="eventImg"
                    :style="inlineBgImage(event.image)"
                >
                </div>
                <div v-else class="calendarEvent">
                    &#128198;	
                </div>
            </div>
        </transition-group>
  </div>
</template>

<script>
import utils from "../../mixins/utils";

export default {
    mixins: [utils],
    props:{
        item: Object
    }

}
</script>

<style>
.eventContentainer{
    width: 100%;
    margin: 0 auto;
}
.eventItem{
    /* background: red; */
    display: grid;
    grid-template-areas: 'img text';
    grid-template-columns: 150px 1fr;
    grid-template-rows: 1fr;
    gap: 20px;
    border-bottom: 1px #767676 solid;
    margin-bottom: 10px;
    padding: 10px;
    transition: all 1s ease;
}
.eventText{
    /* background: gray; */
    grid-area: text;
    display: grid;
    color: #424242;
    line-height: 22px;
}
 .eventImg{
    /* background: orange; */
    grid-area: img;
    justify-items: center;
    align-items: center;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    transition: all 1s;
}
.calendarEvent{
    grid-area: img;
    justify-self: center;
    align-self: center;
    font-size: 6em;
}
.titleEvent{
    margin-bottom: 5px;
}
.subtitleEvent{
    margin-bottom: 5px;
    color: #545454;
}
.eventYears{
    font-size: 14px;
    font-style: italic;
    text-decoration-line: underline;
    font-weight: normal;
}
.descriptionEvent{

}

.events-enter-from, .events-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.events-leave-active {
  position: absolute;
}
.events-move {
  transition: all 1s;
}
@media (max-width: 700px) {
    .eventItem{
        grid-template-areas: 'text';
        grid-template-columns:  1fr;
       
    }
    .calendarEvent{
        display: none;
    }
}

</style>